export default __webpack_public_path__ + "static/media/ic_brand_placeholder.b7687683.svg";